import React, { Component } from 'react';

import { SR_API_ACTION_ARCHIVE_RENTLINX_LISTING_LEAD } from 'api/actionTypes';

import { USER_ROLE_ADMIN } from 'common/userRoles';
import setNullEmptyValues from 'common/util/setNullEmptyValues';

import branch from 'client/core/branch';

import postWithState from 'client/actions/postWithState';
import RentlinxLeadActions from 'client/actions/RentlinxLead';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles from 'client/helpers/allowedRoles';
import { SCREEN_ID_ADMIN_RENTLINX_LEAD } from 'client/constants/screenIds';

import H1 from 'client/components/H1';
import SrLogo from 'client/components/SrLogo';
import SrRentlinxLeadNotesModal from 'client/components/SrRentlinxLeadNotesModal';
import SrArchiveListingLeadModal from 'client/components/SrArchiveListingLeadModal';
import SrHouseholdKanbanBoardCardV2 from 'client/components/SrHouseholdKanbanBoardCardV2/SrHouseholdKanbanBoardCardV2';

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_RENTLINX_LEAD)
@withScrollToTop
@branch(({ match }) => ({
  currentUser: ['currentUser'],
  rentlinxLead: ['rentlinxLead', 'byId', match.params.rentlinxLeadId],
}))
class RentlinxLeadPage extends Component {
  static fetchData(match, inject) {
    const rentlinxLeadId = Number(match.params.rentlinxLeadId);

    return RentlinxLeadActions.getById(inject, { rentlinxLeadId });
  }

  static getPageMetadata = () => ({
    pageTitle: 'Admin Rentlinx Lead | Sunroom Rentals',
    section: 'Admin',
  });

  constructor() {
    super();

    this.state = {
      rentlinxLeadIdToNotes: null,
      archiveRentlinxListingLeadId: null,
    };
  }

  _onClickArchive = (archiveRentlinxListingLeadId) => {
    this.setState({ archiveRentlinxListingLeadId });
  };

  _reloadData = async () => {
    const { dispatch, match } = this.props;
    const rentlinxLeadId = Number(match.params.rentlinxLeadId);

    await dispatch(RentlinxLeadActions.getById, { rentlinxLeadId });
  };

  _onSubmitArchiveListing = async (values) => {
    const { dispatch } = this.props;
    const { archiveRentlinxListingLeadId } = this.state;

    await dispatch(postWithState, {
      action: SR_API_ACTION_ARCHIVE_RENTLINX_LISTING_LEAD,
      payload: setNullEmptyValues({
        rentlinxListingLeadId: archiveRentlinxListingLeadId,
        archiveReasons: values.archiveReasons,
        archiveReasonsDescription: values.archiveReasonsDescription,
        partnerArchiveReason: values.partnerArchiveReason,
      }),
    });

    this._reloadData();

    this.setState({ archiveRentlinxListingLeadId: null });
  };

  render() {
    const { rentlinxLeadIdToNotes, archiveRentlinxListingLeadId } = this.state;
    const {
      dispatch,
      currentUser,
      rentlinxLead,
      match: {
        params: { rentlinxLeadId },
      },
    } = this.props;

    return (
      <div className="page-householdDashboard">
        <div className="admin-navbar">
          <div className="logo-container">
            <SrLogo redirectTo="/admin" />
          </div>
        </div>
        <div className="admin-subnav">
          <div className="admin-subnav-left">
            <H1>Lead #{rentlinxLeadId}</H1>
          </div>
        </div>
        {rentlinxLead && (
          <SrHouseholdKanbanBoardCardV2
            id={rentlinxLead.id}
            name={rentlinxLead.name}
            phone={rentlinxLead.phone}
            email={rentlinxLead.email}
            note={rentlinxLead.lastNote}
            frontConversation={rentlinxLead.frontConversation}
            listings={rentlinxLead.listings}
            onClickNote={(note) => this.setState({ rentlinxLeadIdToNotes: note })}
            onClickArchive={(archiveRentlinxListingLeadId) =>
              this.setState({ archiveRentlinxListingLeadId })
            }
          />
        )}
        {rentlinxLeadIdToNotes && (
          <SrRentlinxLeadNotesModal
            rentlinxLeadId={rentlinxLeadIdToNotes}
            dispatch={dispatch}
            currentUser={currentUser}
            onClose={() => this.setState({ rentlinxLeadIdToNotes: null })}
            onUpdate={this._reloadData}
          />
        )}
        {archiveRentlinxListingLeadId && (
          <SrArchiveListingLeadModal
            onClose={() => this.setState({ archiveRentlinxListingLeadId: null })}
            onSubmit={(values) => {
              this._onSubmitArchiveListing(values);
            }}
          />
        )}
      </div>
    );
  }
}

RentlinxLeadPage.displayName = 'RentlinxLeadPage';

export default RentlinxLeadPage;
